/**
 * A global namespace for `keypress` event.
 */
const keypressEvent = 'keypress';
export default keypressEvent;
